export default {
    clientesArray : []
}